import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import Price from '../Price/Price';
import {
  Wrapper,
  ItemWrapper,
  ItemDetails,
  ItemOption,
  ItemGroup,
  EditLink,
  Comments,
  Remove,
  Add,
  Buttons
} from './BasketBarItem.style';
import {GoogleAnalyticsHelper} from '../../helpers/googleAnalytics.helper';
import {PROMOTION_TYPES} from '../../constants/constant';

export class BasketBarItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      removingItem: false
    };
    this.handleUpdateBasket = this.handleUpdateBasket.bind(this);
    this.handleRemoveItem = this.handleRemoveItem.bind(this);
    this.handleAddItem = this.handleAddItem.bind(this);
  }

  handleRemoveItem() {
    const {uuid, quantity, mealData, unitPrice, mealUuid} = this.props.item;

    if (quantity > 1) {
      this.props.updateBasketItemQuantity(this.props.basketUuid, uuid, quantity - 1);
    } else {
      if (this.state.removingItem === true) {
        return;
      }
      this.setState({removingItem: true});
      this.props.removeBasketItem(this.props.basketUuid, uuid);
    }

    GoogleAnalyticsHelper.removeMeal({
      id: mealUuid,
      name: mealData.name,
      price: unitPrice.toString(),
      quantity: quantity ? quantity - 1 : 0,
      category: mealData.categoryCode || ''
    });
  }

  handleAddItem() {
    const {uuid, quantity, mealData, unitPrice, mealUuid} = this.props.item;
    GoogleAnalyticsHelper.addMeal({
      id: mealUuid,
      name: mealData.name,
      price: unitPrice.toString(),
      quantity: quantity ? quantity + 1 : 1,
      category: mealData.categoryCode || ''
    });

    this.props.updateBasketItemQuantity(this.props.basketUuid, uuid, quantity + 1);
  }

  handleUpdateBasket() {
    this.props.editBasket(this.props.item.mealUuid, this.props.item.uuid);
  }

  render() {
    const {item, isTemplateLight} = this.props;
    const renderSelectedOptions = item.selectedOptions && item.selectedOptions.map(option =>
      <ItemOption
        key={`${option.group}${option.selection}`}
        data-rw="menu-page--basket--selected-option "
      >{option.selection}</ItemOption>
    );

    const renderSize = item.mealData.sizesCount && item.mealData.sizesCount > 1 &&
      <span data-rw="menu-page--basket--item-size">{item.size}</span>;

    const renderPrice = item && item.promotion && item.promotion.type === PROMOTION_TYPES.FREE_MEAL ? <FormattedMessage id="meal.free" /> : <Price amount={item.price} />;

    const renderItem = item &&
      <ItemWrapper>
        <ItemDetails onClick={this.handleUpdateBasket}>
          <span>
            <span data-rw="menu-page--basket--item-quantity">{item.quantity}</span> x {renderSize} <span data-rw="menu-page--basket--item-name">{item.mealData.name}</span>
          </span>
          <span data-rw="menu-page--basket--item-price">
            {renderPrice}
          </span>
        </ItemDetails>
      </ItemWrapper>;
    const renderComments = item && item.comments && <Comments>({item.comments})</Comments>;

    return (
      <Wrapper
        data-rw="menu-page--basket--item"
        data-rw-meta={`menu-page--basket--item ${item.mealData.name}`}
      >
        <ItemGroup>
          {renderItem}
          {renderSelectedOptions}
          {renderComments}
          <EditLink
            onClick={this.handleUpdateBasket}
            hasComment={item.comments}
            data-rw="menu-page--basket--item-edit-link"
          >
            {
              !item.comments && !item.selectedOptions.length
                ? (isTemplateLight ? '+ special request' : '(add special request)')
                : '(edit)'
            }
          </EditLink>
        </ItemGroup>
        <Buttons hideButtons={item.promotion && item.promotion.applied && item.promotion.type === PROMOTION_TYPES.FREE_MEAL}>
          <Add
            onClick={this.handleAddItem}
            data-rw="menu-page--basket--increase-item-quantity-button"
          >+</Add>
          <Remove
            onClick={this.handleRemoveItem}
            data-rw="menu-page--basket--remove-item-button"
          >{isTemplateLight ? '−' : 'x'}</Remove>
        </Buttons>
      </Wrapper>
    );
  }
}

BasketBarItem.propTypes = {
  item: PropTypes.object.isRequired,
  editBasket: PropTypes.func.isRequired,
  removeBasketItem: PropTypes.func.isRequired,
  updateBasketItemQuantity: PropTypes.func.isRequired,
  basketUuid: PropTypes.string.isRequired,
  isTemplateLight: PropTypes.bool.isRequired
};

export default BasketBarItem;



// WEBPACK FOOTER //
// ./components/BasketBar/BasketBarItem.js